import {
  InfoCircleOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
  UserOutlined
} from "@ant-design/icons";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import { Avatar, Button, Dropdown, MenuProps, Modal, Typography } from "antd";
import { ReactComponent as HeadphoneIcon } from 'assets/img/headphone.svg';
import LGELogo from "assets/img/lge_logo_v2.svg";
import { getUserInfo } from "features/auth/store/slice";
import { clearStateDocument } from "features/document-management/store/slice";
import { clearStoreChat } from "features/private-chat/store/slice";
import { FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MenuComponent from "./Menu";
import Book from 'assets/img/book.svg';
import styles from "./styles.module.scss";

const { Text } = Typography;

const Header: FC = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const [openModalAbout, setOpenModalAbout] = useState<boolean>(false);

  const user_info = useSelector(getUserInfo);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(clearStoreChat());
    dispatch(clearStateDocument());
    instance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/",
    });
  };

  const handleViewAbout = () => {
    setOpenModalAbout(true)
  };

  const itemsAccount: MenuProps["items"] = [
    {
      label: (
        <div style={{ display: "flex", flexDirection: "column" }} className={styles.item_label}>
          <Text strong style={{ fontWeight: 600, textTransform: "capitalize" }}>
            {user_info?.last_name} {user_info?.first_name}
          </Text>
          <Text
            style={{
              fontWeight: "400",
              fontSize: ".75rem",
            }}
          >
            {user_info?.team_name}
          </Text>
        </div>
      ),
      disabled: true,
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <Box onClick={handleLogout} className={styles.logout}>
          <UploadOutlined rotate={90} />
          <span style={{ fontWeight: "500" }}>Logout</span>
        </Box>
      ),
      key: "3",
    },
  ];

  const itemsAbout: MenuProps["items"] = [
    {
      label: (
        <div onClick={handleViewAbout} style={{ display: 'flex', alignItems: 'center' }} className={styles.item_label}>
          <InfoCircleOutlined />
          <span style={{ fontWeight: "500" }}>About...</span>
        </div>
      ),
      key: "0",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }} className={styles.item_label}>
          <HeadphoneIcon />
          <a href="http://hlm.lge.com/issue/projects/SAPQA" target="_blank" rel="noreferrer">
            <span style={{ fontWeight: "500" }}>Q&A / </span>
            <span style={{ fontWeight: "500" }}>Request</span>
          </a>
        </div>
      ),
      key: "3",
    },
    {
      label: (
        <div style={{ display: 'flex', alignItems: 'center' }} className={styles.item_label}>
          <img
            src={Book}
            alt=''
            style={{
              width: 16,
              marginRight: 8
            }}
          />
          <a href="http://collab.lge.com/main/pages/viewpage.action?pageId=2639609169" target="_blank" rel="noreferrer">
            <span style={{ fontWeight: "500" }}>User Guide</span>
          </a>
        </div>
      ),
      key: "4",
    },
  ];

  return (
    <>
      <Box className={styles.header}>
        <a href='/home' className={styles.logo}>
          <div className={styles.content_logo}>
            <img className={styles.logo_img} src={LGELogo} alt="" />
            <div className={styles.logo_text}>
              <div className={styles.content_text}>SAP</div>
              <div className={styles.sub_text}>
                Security AI Portal
              </div>
            </div>
          </div>
        </a>
        <div className={styles.menu_list}>
          <MenuComponent />
        </div>
        <div className={styles.user_info}>
          <Dropdown
            menu={{ items: itemsAbout }}
            trigger={["click"]}
            className={styles.question}
          >
            <QuestionCircleOutlined />
          </Dropdown>
          <Dropdown
            menu={{ items: itemsAccount }}
            trigger={["click"]}
            className={styles.avatar}
          >
            <Avatar size="large" icon={<UserOutlined />} />
          </Dropdown>
        </div>
      </Box>
      <Modal
        open={openModalAbout}
        centered
        closable={false}
        onOk={() => setOpenModalAbout(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => setOpenModalAbout(false)}>
            Confirm
          </Button>,
        ]}
        className={styles.modal_about}
      >
        <InfoCircleOutlined size={40} />
        <span>SAP (Security AI Portal)</span>
        <span>Developed by TV S&C Task. All Rights Reserved.</span>
        <span>Version 2.0 (2025-04-22)</span>
      </Modal>
    </>
  );
};

export default Header;
